import ITransitionsProps from "@/interfaces/Props/@extended/ITransitionsProps";
import { Box, Fade, FadeProps, Grow } from "@mui/material";
import { forwardRef } from "react";

const Transitions = forwardRef<JSX.Element, ITransitionsProps & FadeProps>(
  ({ children, position = "top-left", type = "grow", ...others }, ref) => {
    let positionSX = {
      transformOrigin: "0 0 0",
    };

    switch (position) {
      case "top-right":
      case "top":
      case "bottom-left":
      case "bottom-right":
      case "bottom":
      case "top-left":
      default:
        positionSX = {
          transformOrigin: "0 0 0",
        };
        break;
    }

    return (
      <Box ref={ref}>
        {type === "grow" && (
          <Grow {...others}>
            <Box sx={positionSX}>{children}</Box>
          </Grow>
        )}
        {type === "fade" && (
          <Fade
            {...others}
            timeout={{
              appear: 0,
              enter: 300,
              exit: 150,
            }}
          >
            <Box sx={positionSX}> {children} </Box>
          </Fade>
        )}
      </Box>
    );
  }
);

export default Transitions;
